function agileApiExtractErrorString(error) {
    // error is from a .catch(error) from axios
    if (error.response) {
        if (error.response.data) {
            try {
                return error.response.data.detail + ": " + error.response.data.error;
            } catch (e) {
                console.error(e);
            }
        }
        return error.response.status;
    }
    return error;
}

/**
 * A Promise-based wrapper for the Agile Solutions BookingAPI,
 * using the Axios library.
 *
 * Generally, there is a method for each API endpoint.
 * Each method returns a Promise.
 *
 * On success, the promise will resolve to the object returned
 * by the API endpoint.
 *
 * On failure, the promise will reject with the Axios error
 * object.
 */

import axios from "axios";
import moment from "moment";
import jQuery from "jquery";

export const AgileAPI = {
    /**
     * Base URL of the API endpoints
     */
    
    login: function(username, password) {
        return new Promise(function(resolve, reject) {
            console.debug("Logging in...");

            var form = new FormData();
            form.set("username", username);
            form.set("password", password);
            form.set("action", "login");
            axios
                .post("login", form)
                .then(function(response) {
                    console.info("AgileAPI.login: %O", response.data);
                    if (resolve) resolve(response.data);
                })
                .catch(function(error) {
                    console.error("AgileAPI.login: %O", error);
                    if (reject) reject(error);
                });
        });
    },

    fetchProfile: function(username) {
        return new Promise(function(resolve, reject) {
            console.debug("AGILE-API Fetch profile", username);

            var url =  "booking/customers/" + encodeURIComponent(username);
            console.log(url);
            axios
                .get(url)
                .then(function(response) {
                    console.info("AgileAPI.fetchProfile:", response.data);
                    if (resolve) resolve(response.data);
                })
                .catch(function(error) {
                    console.error("AgileAPI.fetchProfile:", error, error.response.data);
                    if (reject) reject(error);
                });
        });
    },

    updateProfile: function(username, profile) {
        return new Promise(function(resolve, reject) {
            console.debug("AGILE-API Updating profile", username);

            var url =  "booking/customers/" + encodeURIComponent(username);
            console.log(url);
            axios
                .patch(url, profile, { withCredentials: true })
                .then(function(response) {
                    console.info("AgileAPI.updateProfile: OK");
                    if (resolve) resolve(response);
                })
                .catch(function(error) {
                    console.error("AgileAPI.updateProfile:", error, error.response.data);
                    if (reject) reject(error);
                });
        });
    },

    /**
     * Return a list of rental locations.
     */
    getLocations: function(userId, locationType) {
        return new Promise(function(resolve, reject) {
            console.debug("AGILE-API Retrieving locations...");
            var url = "booking/locations"
            if(userId){
                url += "?userid="+encodeURIComponent(userId)+"&locationType="+encodeURIComponent(locationType);
            }

            axios
                .get(url)
                .then(function(response) {
                    console.info("AgileAPI.getLocations: %O", response.data);
                    if (resolve) resolve(response.data);
                })
                .catch(function(error) {
                    console.error("AgileAPI.getLocations: %O", error);
                    if (reject) reject(error);
                });
        });
    },

    /**
     * Return a list of quotes for the given quoteRequest object.
     */
    getQuotes: function(quoteRequest) {
        return new Promise(function(resolve, reject) {
            console.debug("Retrieving quotes...");
            try {
 
                axios
                    .post("booking/quotes", quoteRequest, { withCredentials: true })
                    .then((response) => {
                        console.info("AgileAPI.getQuotes: %O");//, response.data);
                        if (resolve) resolve(response.data);
                    })
                    .catch(function(error) {
                        console.error("AgileAPI.getQuotes: %O", error);
                        if (reject) reject(error);
                    });
                
            } catch (err) {
                console.error(err);
                return {};
            }
        });
    },

    /**
     * Return the image of a car from CarImagesOnGroupWeb (car images from quotes).
     */
     getCarImage: function(carId) {
        return new Promise(function(resolve, reject) {
            console.debug("Retrieving car image...");

            axios
                .get(`booking/image?carId=${carId}`, { withCredentials: true })
                .then((response) => {
                    console.info("AgileAPI.getCarImage");//, response.data);
                    if (resolve){
                        // for a different a different configuration of the CarImageEndpoint, convert CLOB to base64 and return a string
                        //const buf = "data:image/jpeg;" + response.data;
                        // third way, if i can get binary data from the backend
                        //const buf = Buffer.from(response.data,"binary").toString('base64');
                        //console.log(buf.toString());
                        //const blob = new Blob([buf], {type: "image/jpeg"});
                        //resolve(buf);

                        resolve(response.data);
                    }

                })
                .catch(function(error) {
                    console.error("AgileAPI.getCarImage: ", error);
                    if (reject) reject(error);
                });
        });
    },

    /**
     * Return Quote KmPriceSurcharge.
     */
    getKmPriceSurchargeForQuote: function(priceSurchargeRequest) {
        // need pricelistid, pricelistrowid, datetime out, datetime in, no of km selected, pickuplocationID, returnLocationId
        return new Promise(function(resolve, reject) {
            console.debug("Retrieving KmPriceSurcharge...");

            axios
                .post("booking/quotes/calculateSurcharge", priceSurchargeRequest, { withCredentials: true })
                .then(function(response) {
                    console.info("AgileAPI.getKmPriceSurchargeForQuote success: %O", response.data);
                    if (resolve) resolve(response.data);
                })
                .catch(function(error) {
                    console.error("AgileAPI.getKmPriceSurchargeForQuote error: %O", error);
                    if (reject) reject(error);
                    //if (resolve) resolve({priceForKmSurcharge:31337});
                });
        });
    },

    /**
     * Submit a bookingRequest object.
     */
    postBooking: function(bookingRequest) {
        return new Promise(function(resolve, reject) {
            console.debug("Submitting booking: %O", bookingRequest);

            axios
                .post("booking/bookings", bookingRequest, { withCredentials: true })
                .then(function(response) {
                    console.info("ok AgileAPI.postBooking:", response.data);
                    if (resolve) resolve(response.data);
                })
                .catch(function(error) {
                    console.log(agileApiExtractErrorString(error));
                    if (reject) reject(agileApiExtractErrorString(error));
                });
        });
    },

    getQuotesSharedCars: function(quoteRequest) {
        return new Promise(function(resolve, reject) {
            var url =  "sharing/cars?" + jQuery.param(quoteRequest);
            axios
                .get(url, { withCredentials: true })
                .then(function(response) {
                    console.info("ok AgileAPI.getQuotesSharedCars:", response.data);
                    if (resolve) resolve(response.data);
                })
                .catch(function(error) {
                    console.error("err AgileAPI.getQuotesSharedCars:", error);
                    if (reject) reject(error);
                });
        });
    },

    getReservationSharedCar: function(carId, dateRangeFrom) {
        return new Promise(function(resolve, reject) {
            var url =  "sharing/cars/" + carId + "/reservations";
            if (dateRangeFrom) {
                url += "?from=" + encodeURIComponent(dateRangeFrom.toISOString());
            }
            axios
                .get(url, { withCredentials: true })
                .then(function(response) {
                    console.info("ok AgileAPI.getReservationSharedCar:", JSON.stringify(response.data));
                    // Loop and add momentjs wrappers
                    for (var i = 0; i < response.data.length; i++) {
                        var reservation = response.data[i];
                        reservation.dateRange.from = moment(reservation.dateRange.from);
                        reservation.dateRange.to = moment(reservation.dateRange.to);
                        response.data[i] = reservation;
                    }
                    if (resolve) resolve(response.data);
                })
                .catch(function(error) {
                    console.error("err AgileAPI.getReservationSharedCar:", error);
                    if (reject) reject(error);
                });
        });
    },

    postSharedCarReservation: function(carId, reservation) {
        return new Promise(function(resolve, reject) {
            var url =  "sharing/cars/" + carId + "/reservations";
            axios
                .post(url, reservation, { withCredentials: true })
                .then(function(response) {
                    console.info("ok AgileAPI.postSharedCarReservation:", response.data);
                    if (resolve) resolve(response.data);
                })
                .catch(function(error) {
                    console.error("err AgileAPI.postSharedCarReservation:", error, error.response.data);
                    console.log(agileApiExtractErrorString(error));
                    if (reject) reject(agileApiExtractErrorString(error));
                });
        });
    },

    getSharingReservations: function() {
        return new Promise(function(resolve, reject) {
            var url =  "sharing/reservations";
            axios
                .get(url, { withCredentials: true })
                .then(function(response) {
                    console.info("ok .AgileAPI.getSharingReservations:", response.data);
                    if (resolve) resolve(response.data);
                })
                .catch(function(error) {
                    console.error("err AgileAPI.getSharingReservations:", error);
                    if (reject) reject(error);
                });
        });
    },

    sendChatMessage: function(customerUUID, topic, content) {
        return new Promise(function(resolve, reject) {
            var url =  "chat/topics/" + topic;
            axios
                .post(url, { to: customerUUID, content: content }, { withCredentials: true })
                .then(function(response) {
                    console.info("ok .AgileAPI.sendChatMessage:", response.data);
                    if (resolve) resolve(response.data);
                })
                .catch(function(error) {
                    console.error("err AgileAPI.sendChatMessage:", error, error.response.data);
                    if (reject) reject(error);
                });
        });
    },
};
